export default __webpack_public_path__ + "static/media/404.1d45b0c6.svg";